import classnames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';

import { PARAMS, PROGRAM_VIEW } from 'src/app/constants/route';
import { VIDEO_ITEM_TYPE } from 'src/app/constants/video';
import { withStyles } from 'src/app/helpers/styles';
import { Program } from 'src/app/models/program';

interface MyProps {
  program: Program;
  type: VIDEO_ITEM_TYPE;
  railAnalytics?: string;
}

@withStyles({
  base: [],
  desktop: [require('./VideoItemProgramName.desktop.scss')]
})
export class VideoItemProgramName extends React.Component<MyProps> {
  shouldComponentUpdate(): boolean {
    return false;
  }

  render(): JSX.Element {
    const { program, type, railAnalytics } = this.props;
    const programLink = PROGRAM_VIEW.replace(PARAMS.SLUG, program.slug);
    return (
      <Link
        className={classnames('d-flex fs-12 fg-gray-light hg-secondary', 'video-item-program-name--' + type)}
        to={{ pathname: programLink, state: { railAnalytics } }}
      >
        {program.name}
      </Link>
    );
  }
}
